import { SEPARATOR_COLON, SEPARATOR_PIPE, SEARCH_IDENTIFIER_WHSEARCH, WHSEARCH_NO_SEARCHTERM, WHSEARCH, ONE, SEPARATOR_SEMICOLON, WHSEARCH_LOC, SEARCH_IDENTIFIER_SEARCHBARSEARCH, SEARCH_TYPE_TYPED, SEARCHBAR_SEARCH, SEARCH_TYPE, SEARCH_TYPE_MARKETING, SEARCH_TYPE_TYPEAHEAD, ESPOT, NOT_APPLICABLE, ITEM_TYPE_PRODUCT, ITEM_TYPE_AD, EXTERNAL_IDENTIFIER, URL_PATTERN_PDP, URL_PATTERN_SEARCH, PARAM_KEYWORD, TRACK_TYPE_SEARCH } from "./constants.js";
const processNavAnalyticData = (analyticObj) => {
  const component = analyticObj == null ? void 0 : analyticObj.component;
  const type = (component == null ? void 0 : component.type) ?? "";
  const identifier = (component == null ? void 0 : component.identifier) || (analyticObj.pageName ? analyticObj.pageName : populatePageName());
  const trackedData = ((component == null ? void 0 : component.trackedData) || []).map(
    (item) => (item == null ? void 0 : item.toLowerCase()) ?? ""
  );
  return trackedData.length ? `${type}${SEPARATOR_COLON}${identifier}${SEPARATOR_PIPE}${trackedData.join(SEPARATOR_PIPE)}` : `${type}${SEPARATOR_COLON}${identifier}`;
};
const processATCContShopViewCart = (ATCObject) => {
  var _a, _b;
  return `${(_a = ATCObject == null ? void 0 : ATCObject.component) == null ? void 0 : _a.type}${SEPARATOR_COLON}${(_b = ATCObject == null ? void 0 : ATCObject.component) == null ? void 0 : _b.identifier}`;
};
const processSocialShareAnalyticData = (socialShareObj) => {
  var _a, _b;
  return `${(_a = socialShareObj == null ? void 0 : socialShareObj.component) == null ? void 0 : _a.type}${SEPARATOR_COLON}${(_b = socialShareObj == null ? void 0 : socialShareObj.component) == null ? void 0 : _b.identifier}`;
};
const processProductAccordionAnalytics = (accordionObj) => {
  var _a, _b;
  return `${(_a = accordionObj == null ? void 0 : accordionObj.component) == null ? void 0 : _a.type}${SEPARATOR_COLON}${(_b = accordionObj == null ? void 0 : accordionObj.component) == null ? void 0 : _b.identifier}`;
};
const processProductNotFoundAnalytics = (ProdNotFoundObj) => {
  var _a, _b;
  return `v1: ${(_a = ProdNotFoundObj == null ? void 0 : ProdNotFoundObj.component) == null ? void 0 : _a.pageName} v2: ${(_b = ProdNotFoundObj == null ? void 0 : ProdNotFoundObj.component) == null ? void 0 : _b.pageType}`;
};
const processViewExternalLinkModalAnalytics = (ExternalLinkModalObj) => {
  var _a, _b;
  return `${(_a = ExternalLinkModalObj == null ? void 0 : ExternalLinkModalObj.component) == null ? void 0 : _a.type}${SEPARATOR_COLON}${(_b = ExternalLinkModalObj == null ? void 0 : ExternalLinkModalObj.component) == null ? void 0 : _b.identifier}`;
};
const processSearchAnalyticData = (analyticObj) => {
  const { identifier, keyword, location, searchBar } = analyticObj;
  if (identifier === SEARCH_IDENTIFIER_WHSEARCH) {
    const kw2 = keyword ? keyword.toLowerCase() : WHSEARCH_NO_SEARCHTERM;
    return `${WHSEARCH}${SEPARATOR_COLON}${ONE}${SEPARATOR_SEMICOLON}${identifier}${SEPARATOR_COLON}${kw2}${SEPARATOR_SEMICOLON}${WHSEARCH_LOC}${SEPARATOR_COLON}${location || ""}`;
  }
  if (!keyword || identifier !== SEARCH_IDENTIFIER_SEARCHBARSEARCH) {
    return keyword ? `${identifier}${SEPARATOR_COLON}${keyword.toLowerCase()}` : "";
  }
  const kw = keyword.toLowerCase();
  const base = `${SEARCHBAR_SEARCH}${SEPARATOR_COLON}${ONE}${SEPARATOR_SEMICOLON}${identifier}${SEPARATOR_COLON}${kw}${SEPARATOR_SEMICOLON}${SEARCH_TYPE}${SEPARATOR_COLON}`;
  const searchType = searchBar == null ? void 0 : searchBar.searchType;
  if (searchType === SEARCH_TYPE_TYPED) return `${base}${SEARCH_TYPE_TYPED}`;
  if (searchType === SEARCH_TYPE_MARKETING)
    return `${base}${SEARCH_TYPE_MARKETING}`;
  if (searchType === SEARCH_TYPE_TYPEAHEAD) {
    return `${base}${SEARCH_TYPE_TYPEAHEAD}${SEPARATOR_PIPE}${(searchBar == null ? void 0 : searchBar.typeaheadGroup) || ""}`;
  }
  return base;
};
const extractURLData = (url, type, isExternal) => {
  if (isExternal || type !== ITEM_TYPE_PRODUCT && type !== ITEM_TYPE_AD) {
    return isExternal ? `${SEPARATOR_PIPE}${EXTERNAL_IDENTIFIER}` : "";
  }
  const pdpMatch = url.match(URL_PATTERN_PDP);
  if (pdpMatch == null ? void 0 : pdpMatch[1]) {
    return `${SEPARATOR_PIPE}${ITEM_TYPE_PRODUCT}${SEPARATOR_PIPE}${pdpMatch[1]}`;
  }
  if (!url.match(URL_PATTERN_SEARCH)) return "";
  let searchURL;
  try {
    searchURL = new URL(
      url.startsWith("http") ? url : `${window.location.origin}${url}`
    );
    const keyword = searchURL.searchParams.get(PARAM_KEYWORD);
    return keyword ? `${SEPARATOR_PIPE}${TRACK_TYPE_SEARCH}${SEPARATOR_PIPE}${keyword.toLowerCase()}` : "";
  } catch (error) {
    console.error(
      "Analytics Error: Reading the keyword param from the URL failed",
      error
    );
    return "";
  }
};
const populatePageName = () => {
  var _a;
  if ((_a = window == null ? void 0 : window.digitalData) == null ? void 0 : _a.pageName) {
    return window.digitalData.pageName;
  }
  return NOT_APPLICABLE;
};
const processAdAnalyticData = (analyticObj) => {
  var _a, _b;
  const { pageName, position, itemCuration, adItem, title, adPlacementData } = analyticObj;
  const ad = adItem || {};
  const urlData = ad.url ? extractURLData(ad.url, (_a = ad.type) == null ? void 0 : _a.toLowerCase(), ad.isExternal) : "";
  const setIdMatch = (_b = ad.url) == null ? void 0 : _b.match(/setID=([0-9]+)/);
  const setId = setIdMatch ? setIdMatch[1] : null;
  const formattedProviders = {
    adbutler: "AdButler",
    adobe: "Adobe",
    criteo: "Criteo",
    costco: "Costco",
    na: "N/A"
  };
  return {
    campaignClick: 1,
    campaignSource: itemCuration ? formattedProviders[itemCuration] : itemCuration,
    campaignSetId: setId,
    campaignId: adPlacementData == null ? void 0 : adPlacementData.campaign_id,
    campaignBannerId: adPlacementData == null ? void 0 : adPlacementData.banner_id,
    espot: [
      ESPOT,
      SEPARATOR_COLON,
      pageName || populatePageName(),
      SEPARATOR_PIPE,
      position,
      SEPARATOR_PIPE,
      itemCuration || NOT_APPLICABLE,
      SEPARATOR_PIPE,
      ad.style || NOT_APPLICABLE,
      SEPARATOR_PIPE,
      title ? title.toLowerCase() : NOT_APPLICABLE,
      SEPARATOR_PIPE,
      ad.title ? ad.title.toLowerCase() : NOT_APPLICABLE,
      urlData
    ].join("")
  };
};
const processMultiAttributeAnalyticData = (analyticObj) => {
  let dispatchData = "";
  if (analyticObj == null ? void 0 : analyticObj.trackedData) {
    const parts = analyticObj.trackedData.map(
      (attr) => `${attr.key}${SEPARATOR_COLON}${attr.value}`
    );
    dispatchData = parts.join(SEPARATOR_SEMICOLON);
  }
  return dispatchData;
};
export {
  extractURLData,
  processATCContShopViewCart,
  processAdAnalyticData,
  processMultiAttributeAnalyticData,
  processNavAnalyticData,
  processProductAccordionAnalytics,
  processProductNotFoundAnalytics,
  processSearchAnalyticData,
  processSocialShareAnalyticData,
  processViewExternalLinkModalAnalytics
};
